var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C15.5951 3 17.3928 2.9998 18.6875 3.85645C19.2657 4.239 19.761 4.73434 20.1436 5.3125C21.0002 6.60723 21 8.40493 21 12C21 15.5951 21.0002 17.3928 20.1436 18.6875C19.761 19.2657 19.2657 19.761 18.6875 20.1436C17.3928 21.0002 15.5951 21 12 21C8.40493 21 6.60723 21.0002 5.3125 20.1436C4.73434 19.761 4.239 19.2657 3.85645 18.6875C2.9998 17.3928 3 15.5951 3 12C3 8.40493 2.9998 6.60723 3.85645 5.3125C4.239 4.73434 4.73434 4.239 5.3125 3.85645C6.60723 2.9998 8.40493 3 12 3ZM12 7.34082C9.42675 7.34082 7.34094 9.42678 7.34082 12C7.34082 14.5733 9.42668 16.6592 12 16.6592C14.5732 16.6591 16.6592 14.5733 16.6592 12C16.6591 9.42684 14.5732 7.34091 12 7.34082ZM12 8.91699C13.7025 8.91708 15.0829 10.2975 15.083 12C15.083 13.7026 13.7026 15.0829 12 15.083C10.2973 15.083 8.91699 13.7027 8.91699 12C8.91711 10.2974 10.2974 8.91699 12 8.91699ZM16.8438 6.01172C16.2392 6.01172 15.7482 6.50192 15.748 7.10645C15.748 7.7111 16.2391 8.20117 16.8438 8.20117C17.4482 8.20092 17.9385 7.71094 17.9385 7.10645C17.9383 6.50208 17.4481 6.01198 16.8438 6.01172Z",
    fill: "#204887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInsta);
export default __webpack_public_path__ + "static/media/Footer_insta.f038d252224ea936ba37c38b7b73bd94.svg";
export { ForwardRef as ReactComponent };